import React, { Component } from 'react'
import _ from 'lodash'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
    invalidDateParts,
    missingDateParts,
} from '../../../../../../../helpers/collaborativeIndexations'

class Gregorian extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        resetInvalidField: PropTypes.func.isRequired,
        isInvalidField: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        fieldName: PropTypes.string.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.updateDate = this.updateDate.bind(this)
        this.nextFieldFocus = this.nextFieldFocus.bind(this)
        this.retrieveDatePartValue = this.retrieveDatePartValue.bind(this)
        this.formattedDatePartValue = this.formattedDatePartValue.bind(this)
        this.isDatePartValid = this.isDatePartValid.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.handleBlur = this.handleBlur.bind(this)

        this.day = React.createRef()
        this.month = React.createRef()
        this.year = React.createRef()

        this.state = {
            currentFocus: null
        }
    }

    updateDate(field)
    {
        const { fieldName } = this.props

        this.props.resetInvalidField(fieldName)

        this.props.updateFieldValue(fieldName, {
            year: this.year.current.value,
            month: this.month.current.value,
            day: this.day.current.value,
        })

        this.nextFieldFocus(field)
    }

    nextFieldFocus(field)
    {
        switch(field)
        {
            case 'day':
                if(this.day.current.value.toString().length > 1)
                {
                    this.month.current.focus()
                }
                break
            case 'month':
                if(this.month.current.value.toString().length > 1)
                {
                    this.year.current.focus()
                }
                break
            default:
        }
    }

    handleFocus(event, field)
    {
        event.target.select()

        this.setState({
            currentFocus: field
        })
    }

    handleBlur()
    {
        this.setState({
            currentFocus: null
        })
    }

    retrieveDatePartValue(datePart)
    {
        const { fields, fieldName } = this.props
        if(! fields[fieldName])
        {
            return null
        }

        const datePartValue = fields[fieldName]['parts'][datePart]

        if(! Number.isInteger(datePartValue))
        {
            return null
        }

        return datePartValue
    }

    formattedDatePartValue(datePart)
    {
        const datePartValue = this.retrieveDatePartValue(datePart)

        if(datePartValue === null)
        {
            return ''
        }

        if(this.state.currentFocus === datePart)
        {
            return datePartValue
        }

        if(datePart === 'year')
        {
            return _.trimStart(datePartValue, 0)
        }

        return _.padStart(datePartValue, 2, 0)
    }

    isDatePartValid(datePart)
    {
        const { fieldName } = this.props

        if(! this.props.isInvalidField(fieldName))
        {
            return true
        }

        const invalidParts = invalidDateParts(this.props.fields[fieldName])

        return _.indexOf(invalidParts, datePart) === -1
    }

    render()
    {
        const { t, fields, fieldName } = this.props

        return (
            <div className={'gregorian'}>
                <input
                    type={'number'}
                    ref={this.day}
                    className={classNames('day', {'error': ! this.isDatePartValid('day')})}
                    value={this.formattedDatePartValue('day')}
                    onChange={() => this.updateDate('day')}
                    onFocus={event => this.handleFocus(event, 'day')}
                    onBlur={this.handleBlur}
                    title={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.day.label')}
                    placeholder={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.day.placeholder')}
                />
                <input
                    type={'number'}
                    ref={this.month}
                    className={classNames('month', {'error': ! this.isDatePartValid('month')})}
                    value={this.formattedDatePartValue('month')}
                    onChange={() => this.updateDate('month')}
                    onFocus={event => this.handleFocus(event, 'month')}
                    onBlur={this.handleBlur}
                    title={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.month.label')}
                    placeholder={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.month.placeholder')}
                />
                <input
                    type={'number'}
                    ref={this.year}
                    className={classNames('year', {'error': ! this.isDatePartValid('year')})}
                    value={this.formattedDatePartValue('year')}
                    onChange={() => this.updateDate('year')}
                    onFocus={event => this.handleFocus(event, 'year')}
                    onBlur={this.handleBlur}
                    title={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.year.label')}
                    placeholder={t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.year.placeholder')}
                />
                {this.props.isInvalidField(fieldName) && missingDateParts(fields[fieldName]).length > 0 &&
                    <div className='format-error'>{t('visualizer:toolbar.left.collaborativeIndexationCreation.gregorianForm.formatError')}</div>}
            </div>
        )
    }
}

export default withTranslation()(Gregorian)
